import { Box, Group, Image, Paper, Text } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import classes from './VipClub.module.css';
export type VipRewardItemProps = {
  iconUrl: string;
  title: string;
  description: string;
};
export const VipRewardItem: React.FC<VipRewardItemProps> = ({
  iconUrl,
  title,
  description
}) => {
  const isMobile = useMediaQuery('(max-width: 36em)');
  return <Paper className={classes.box}>
      <Group gap={0} wrap="nowrap">
        <Group wrap="nowrap" miw={{
        sm: 311,
        lg: 447
      }} h={{
        base: 72,
        sm: 92
      }} p={{
        base: 0,
        sm: 20
      }} style={{
        borderRight: isMobile ? 'none' : '1px solid #464F59'
      }}>
          <Box mb={{
          base: 'auto',
          sm: 0
        }}>
            <Image src={iconUrl} w={24} h={24} alt="icon" />
          </Box>
          <Text fz="xs" tt="uppercase" fw={700} visibleFrom="sm" c="var(--text-white)">
            {title}
          </Text>
        </Group>

        <Box ml={{
        base: 10,
        sm: 24,
        lg: 32
      }} p={{
        base: 0,
        sm: 10
      }}>
          <Text fz="xs" tt="uppercase" fw={700} hiddenFrom="sm" c="var(--text-white)">
            {title}
          </Text>
          <Text fz="xs">{description}</Text>
        </Box>
      </Group>
    </Paper>;
};